<template>
  <div class="img-container">
    <v-img
      :contain="contain"
      :src="imageSrc"
      :max-height="maxHeight"
      :height="height"
      :aspect-ratio="aspect"
      :gradient="gradient"
      :max-width="maxWidth"
      v-bind:class="{ round: circle, welcomeBook: borderRadius }"
    >
      <template v-slot:placeholder>
        <v-row
          class="fill-height ma-0"
          style="z-index: 5"
          align="center"
          justify="center"
        >
          <v-progress-circular
            indeterminate
            color="grey lighten-5"
          ></v-progress-circular>
        </v-row>
      </template>
      <slot></slot>
    </v-img>
  </div>
</template>
<script>
import dataAccess from '../../services/service.data-access'
import { isEmpty } from 'lodash'

export default {
  name: 'DisplayImage',
  props: {
    urlPhoto: {
      required: false,
      type: String,
      default: () => ''
    },
    borderRadius: {
      required: false,
      default: () => false
    },
    imageId: {
      required: false
    },
    contain: {
      required: false,
      type: Boolean,
      default: () => false
    },
    maxWidth: {
      required: false,
      type: Number,
      default: () => 280
    },
    maxHeight: {
      required: false,
      type: Number,
      default: () => null
    },
    height: {
      required: false,
      default: () => 'auto'
    },
    aspect: {
      required: false,
      default: () => undefined
    },
    gradient: {
      required: false,
      default: () => ''
    },
    circle: {
      required: false,
      default: () => false
    }
  },
  data: () => ({
    imageSrc: null
  }),
  async created() {
    if (!isEmpty(this.urlPhoto)) {
      this.imageSrc = this.urlPhoto
      console.log(this.imageSrc)
    } else {
      if (!isEmpty(this.imageId)) {
        await this.loadImage(this.imageId)
      }
    }
  },
  methods: {
    async loadImage(imageId) {
      const file = await dataAccess.getImageFile(imageId, this.maxWidth, this.maxHeight)
      this.setImage(file)
    },
    setImage(file) {
      this.imageSrc = URL.createObjectURL(file, {
        type: file.type
      })
    }
  },
  watch: {
    imageId: function (newVal, oldVal) {
      if (!isEmpty(newVal)) {
        this.loadImage(newVal)
      }
    },
    urlPhoto: function (newVal, oldVal) {
      if (!isEmpty(newVal) && newVal !== oldVal) {
        this.imageSrc = this.urlPhoto
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.round {
    border-radius: 50%;
    margin-left: 15px;
    margin-top: 10px;
    margin-bottom: 10px;
}
.welcomeBook {
  border-radius: 3px;
}
</style>
